module.exports = __webpack_public_path__ + "img/98.146771ab.png";